import { render, staticRenderFns } from "./ProvinsiV2.vue?vue&type=template&id=1f851647"
import script from "./ProvinsiV2.vue?vue&type=script&lang=js"
export * from "./ProvinsiV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports